import { movies } from "@/mocks/catalog";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

const watchingTips = [
  { label: "按集数规划时间", text: "长剧适合每天一两集地追，短剧可以在周末一次看完。" },
  { label: "关注人物弧线", text: "电视剧依靠长线铺垫，人物的变化往往比单集情节更重要。" },
  { label: "留意单元结构", text: "部分作品采用单元剧形式，每集相对独立，随时可以进入。" },
];

export default function TvSection() {
  const items = movies.filter((m) => m.genre === "电视剧");

  return (
    <section id="tv" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="电视剧专区"
          title="电视剧：用更长的篇幅陪人物走一程"
          description="电视剧最大的特点是「成长」。它有时间慢慢铺开世界观、塑造配角，也允许你在很多个晚上，和同一群人一起经历起伏。年代、都市与美食人文，是几个耐看的常见方向。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {watchingTips.map((tip) => (
            <div
              key={tip.label}
              className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
                <i className="ri-play-list-add-line text-primary-600"></i>
                {tip.label}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{tip.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}